import React from "react";
import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { SubHeaderLabel } from "../Labels.tsx";

const OtpPasswordUI: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Col xs={12} md={7} className="p-0">
      <div
        className="m-4 p-4 rounded-4 d-flex align-items-center justify-content-center noProject"
        style={{
          height: "calc(100vh - 3rem)",
          marginTop: "2.25rem",
        }}
      >
        <SubHeaderLabel>{t("noSelectedProject.noProjectLabel")}</SubHeaderLabel>
      </div>
    </Col>
  );
};

export default OtpPasswordUI;
